export type DataSettingsPartial = Partial<DataSettings>;

export class DataSettings {
    applyFilter = true;
    applyPaging = true;
    applySort = true;
}


// WEBPACK FOOTER //
// ./~/angular1-template-loader!./src/core/data/dataSettings.ts